export default __webpack_public_path__ + "static/media/3831.68cf6002.png";